export default __webpack_public_path__ + "static/media/robin-canfield-JDlF_d9BDAQ-unsplash.301c3e8d.jpg";